import { Base64 } from "js-base64";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Layer } from "../../../components";
import {
  AppContext,
  checkMobile,
  SET_IDCARD_STATE,
} from "../../../components/AppProvider";
import { AlertLayer } from "../../../components/UI/Dialog";
import ToastMsg, {
  toastMsgObj,
} from "../../../components/UI/Layer/ToastMsg/ToastMsg";
import {
  PostApi1972,
  PostApi221,
  PostApi226,
} from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import { NativeAction } from "../../../modules/utils/HandleWs";
import { IC } from "../../../resources/Assets";
import { closeLayerFn, openLayerFn } from "../../Layout";
import CouponList from "../../common/Coupon/CouponList";
import {
  closeLoadingLayer,
  openLoadingLayer,
} from "../../common/Layer/Loading";
import { getIdCard } from "../Interface/NFTF/NativeApi";
import InputSymptom from "./InputSymptom";
import ReceiptCard from "./ReceiptCard";
import ReceiptComplete from "./ReceiptComplete";
import ReceiptIframe from "./ReceiptIframe";
import ReceiptMain from "./ReceiptMain";
import ReceiptPharm from "./ReceiptPharm";
import ReceiptPharmSearch from "./ReceiptPharmSearch";
import ReceiptStepTwo from "./ReceiptStepTwo";
import ReceiptTarget from "./ReceiptTarget";
import ReceiptTime from "./ReceiptTime";
import useTitle from "../../../modules/hooks/useTitle";

const ReceiptIndex = props => {
  const { userinfo, cfg, phonecfg, nftfDoctor, dispatch, idCardState } =
    useContext(AppContext);
  useTitle("진료예약_비대면_접수");
  // pageIdx main:1 ReceiptTime:2 receiptTarget:3 symptom:4 payCard:5 receiptComplete:6
  // 이동 순서 1->2->4->3->5->6
  const [pageIdx, setPageIdx] = useState(
    props.match.params.pageIdx ? parseInt(props.match.params.pageIdx) : 1
  );
  const [loading, setLoading] = useState(false);
  const hsptData = JSON.parse(Base64.decode(props.match.params.hsptData));

  const hpKey = hsptData.hpKey;
  const startTime = hsptData.callSTime;
  const endTime = hsptData.callETime;
  const returnUrl = cfg.nftfReturnUrl;

  // const [hsptInfo, setHsptInfo] = useState();
  const [hsptInfo, setHsptInfo] = useState();
  const [trgtInfo, setTrgtInfo] = useState();
  const [fileTemp, setFileTemp] = useState();

  const [smptInfo, setSmptInfo] = useState();
  const [cardInfo, setCardInfo] = useState();
  const [fileOrigin, setFileOrigin] = useState();
  const [imgTempView, setImgTempView] = useState(0);

  const [pharmInfo, setPharmInfo] = useState();
  const [pharmInfoTemp, setPharmInfoTemp] = useState();

  // 가족정보(진료 대상자)
  const [familyInfo, setFamilyInfo] = useState();

  // 사용 쿠폰 정보
  const [couponInfo, setCouponInfo] = useState();

  const [moveUrl, setMoveUrl] = useState();
  const [backStep, setBackStep] = useState(false);

  // const [modalView, setModalView] = useState(true);
  const [modalView, setModalView] = useState(false);
  const [couponLayerView, setCouponLayerView] = useState(true);
  const [issueCpnNo, setIssueCpnNo] = useState("");

  // 쿠폰함 열기
  const [couponListView, setCouponListView] = useState(false);

  // alert 메세지
  const [viewMsgLayer, setViewMsgLayer] = useState(false);
  const [msgState, setMsgState] = useState("default");

  const getMessage = () => {
    if (msgState === "time") {
      return messageLayerData.time;
    } else if (msgState === "target") {
      return messageLayerData.target;
    } else if (msgState === "card") {
      return messageLayerData.card;
    } else if (msgState === "symptom") {
      return messageLayerData.symptom;
    } else {
      return messageLayerData.failed;
    }
  };

  const messageLayerData = {
    time: {
      headerIcon: "",
      title: "예약 시간을 입력해주세요",
      desc: ["예약시간 정보를 입력하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    symptom: {
      headerIcon: "",
      title: "증상을 입력해주세요",
      desc: ["증상 정보를 입력하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    target: {
      headerIcon: "",
      title: "신분증 이미지를 등록해주세요",
      desc: ["신분증 이미지를 등록하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    card: {
      headerIcon: "",
      title: "결제 카드를 추가해주세요",
      desc: ["카드를 추가하신 후 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    handleConfirmCB: "",
  });

  const handleDialog = (title, msg, handleConfirmCB) => {
    setDialog({
      title: title,
      msg: msg,
      handleConfirmCB: handleConfirmCB,
    });

    openLayerFn($(".alert-layer"));
  };
  // 다이얼로그 ]]

  const receiptRsrv = (setBtnActive, setCompleteLayerView) => {
    openLoadingLayer();
    PostApi221(userinfo, cfg, phonecfg, {
      hpKey: hpKey,
      license: hsptInfo.doctor.doctorLicense,
      appDrName: hsptInfo.doctor.doctorName,
      appHour: hsptInfo.hour.toString() + hsptInfo.min.toString(),
      appCls: "1",

      symtmDesc: smptInfo.symptomText,
      cardSeqNo: cardInfo.seqNo,
      idCardFileNm: trgtInfo ? trgtInfo.fileName : "",
      idCardEncFile: trgtInfo ? trgtInfo.file : "",
      rqstRelCd: familyInfo ? familyInfo.rqstRelCd : "",
      famzSeqNo: familyInfo ? familyInfo.famzSeqNo : "",
      // rqstRelCd: trgtInfo ? trgtInfo.rqstRelCd : "",
      // famzSeqNo: trgtInfo ? trgtInfo.famzSeqNo : "",
      seqNo: props.match.params.seqNo ? props.match.params.seqNo : "",

      phKey: pharmInfo ? pharmInfo.phKey : "",
      pharmName: pharmInfo ? pharmInfo.pharmName : "",
      pharmFaxNum: pharmInfo ? pharmInfo.pharmFaxNum : "",
      pharmTelNo: pharmInfo ? pharmInfo.pharmTelNo : "",
      issueCpnNo: couponInfo ? couponInfo.issueCpnNo : "",
    })
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          closeLoadingLayer();
          setBtnActive(true);
          if (res.resultCode == "-1") {
            handleDialog(
              "",
              "이미 접수하신 내역이 있습니다.\n예약현황에서 취소 후 신규 접수가 가능합니다.",
              "err"
            );
          } else if (res.resultCode == "-2") {
            handleDialog(
              "",
              "접수가 불가능한 시간입니다. \n다른 시간을 선택해 주세요",
              "err"
            );
          } else if (res.resultCode == "-3") {
            handleDialog("", "수정에 실패하였습니다. ", "err");
          } else if (res.resultCode == "000") {
            // setIdCard(trgtInfo.file, trgtInfo.fileName);
            if (setCompleteLayerView) {
              setCompleteLayerView(true);
            } else {
              _O.Open("/resrvList");
            }
          }
        } else {
          closeLoadingLayer();
          handleDialog("", "접수실패: " + res.resultCode, "err");
          setBtnActive(true);
        }
      })
      .catch(err => {
        closeLoadingLayer();
        console.log(err);
        handleDialog("", "접수실패", "err");
        setBtnActive(true);
      });
  };

  const getReceiptData = () => {
    PostApi226(userinfo, cfg, phonecfg, props.match.params.seqNo)
      .then(res => {
        setHsptInfo(res.result.hsptInfo);
        setSmptInfo(res.result.smptInfo);
        setCardInfo(res.result.cardInfo);
        setPharmInfo(res.result.pharmInfo);
        setCouponInfo(res.result.cpnInfo);

        if (res.result.famzInfo && res.result.famzInfo.rqstRelCd === "FAMZ") {
          setFamilyInfo({
            rqstRelCd: "FAMZ",
            famzNm: res.result.famzInfo.famzNm,
            famzBirthDt: res.result.famzInfo.famzBirthDt,
            famzGndr: res.result.famzInfo.famzGndr,
            famzTelNo: res.result.famzInfo.famzTelNo,
            famzFileNm: res.result.famzInfo.famzFileNm,
            famzSeqNo: res.result.famzInfo.famzSeqNo,
          });

          // 진료 신청한 환자의 이름
          if (getIdCard(res.result.famzInfo.famzFileNm) === "-1") {
            setTrgtInfo({ file: "", fileName: "" });
          }
        } else {
          setFamilyInfo({
            rqstRelCd: "PRCP",
            famzNm: userinfo.userName,
            famzBirthDt: userinfo.birth,
            famzGndr: userinfo.sex,
            famzTelNo: userinfo.userPhone,
            famzFileNm: userinfo.userName,
            famzSeqNo: "",
          });
        }
        setLoading(true);
      })
      .catch(err => {
        console.log("err:: ", err);
      });
  };

  const getMyCardList = () => {
    PostApi1972(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.result.length > 0) {
          for (let i = 0; i < res.result.length; i++) {
            if (res.result[i].usedYn === "Y") {
              setCardInfo(res.result[i]);
              break;
            }
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const [toastView, setToastView] = useState({
    view: false,
    msgType: "cardAdd",
  });

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#FFFFFF");

    window.addEventListener("message", e => {
      if (e.data.messageId === "reload") {
        // 수신 후 처리
        setPageIdx(5);
        setToastView({
          view: true,
          msgType: "cardAdd",
        });
      }
    });

    if (props.match.params.seqNo) {
      // if (checkMobile() === "IOS") {
      // }
      setTrgtInfo({ file: "", fileName: "" });
      getReceiptData();
    } else {
      getMyCardList();
      setFamilyInfo({
        rqstRelCd: "PRCP",
        famzNm: userinfo.userName,
        famzBirthDt: userinfo.birth,
        famzGndr: userinfo.sex,
        famzTelNo: userinfo.userPhone,
        famzFileNm: userinfo.userName,
        famzSeqNo: "",
      });

      // 진료 신청한 환자의 이름
      if (getIdCard(userinfo.userName) === "-1") {
        setTrgtInfo({ file: "", fileName: "" });
      }
      setLoading(true);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      toastView.view &&
        setToastView({
          view: false,
          msgType: "cardAdd",
        });
    }, 5000);
  }, [toastView]);

  useEffect(() => {
    if (modalView) {
      NativeAction(phonecfg, "statusColor", "#999999");
    } else {
      NativeAction(phonecfg, "statusColor", "#FFFFFF");
    }
  }, [modalView]);

  const rtnEvent = (value, status) => {
    if (value != "-1") {
      if (status === "1") {
        setFileTemp({
          file: decodeURIComponent(value),
          fileName: userinfo.userName + ".jpg",
        });

        setImgTempView(1);
      } else {
        setTrgtInfo({
          file: decodeURIComponent(value),
          fileName: userinfo.userName + ".jpg",
        });
        setFileTemp({
          file: decodeURIComponent(value),
          fileName: userinfo.userName + ".jpg",
        });
      }
    } else {
      setFileTemp({
        file: "",
        fileName: "",
      });
    }
  };

  const buttonClickEvent = data => {
    setPharmInfo(data);
    setPageIdx(7);
  };

  // useEffect(() => {
  //   if (
  //     checkMobile() === "IOS" &&
  //     parseInt(phonecfg.version.split(".")[2]) < 58
  //   ) {
  //     window.NativeInterface = {
  //       getIdCardRtn: (value1, value2) => {
  //         rtnEvent(value1, value2);
  //       },
  //     };
  //   }
  // }, [trgtInfo]);

  useEffect(() => {
    if (idCardState.reload) {
      if (
        idCardState &&
        idCardState.data &&
        idCardState.data != null &&
        idCardState.data.value2 != "0"
      ) {
        rtnEvent(idCardState.data.value1, idCardState.data.value2);
      }

      dispatch({
        type: SET_IDCARD_STATE,
        data: {
          type: "RELOAD",
        },
      });
    }
  }, [trgtInfo, idCardState.reload]);

  return (
    <Fragment>
      {loading && (
        <Fragment>
          {couponListView ? (
            <CouponList
              useCoupon={couponInfo}
              setUseCoupon={setCouponInfo}
              setCouponListView={setCouponListView}
            />
          ) : (
            <Fragment>
              {pageIdx === 1 && (
                <ReceiptMain
                  hederTitle={
                    !props.match.params.seqNo
                      ? "비대면진료 예약 (1/2)"
                      : "예약정보 수정"
                  }
                  hpKey={hpKey}
                  hsptData={hsptData}
                  setPageIdx={setPageIdx}
                  hsptInfo={hsptInfo}
                  trgtInfo={trgtInfo}
                  familyInfo={familyInfo}
                  smptInfo={smptInfo}
                  cardInfo={cardInfo}
                  pharmInfo={pharmInfo}
                  couponInfo={couponInfo}
                  setCouponInfo={setCouponInfo}
                  modalView={modalView}
                  setModalView={setModalView}
                  submit={receiptRsrv}
                  seqNo={
                    props.match.params.seqNo ? props.match.params.seqNo : null
                  }
                  receiptStatus={
                    props.match.params.status ? props.match.params.status : null
                  }
                  setCouponListView={setCouponListView}
                />
              )}
              {pageIdx === 2 && (
                <ReceiptTime
                  hederTitle={
                    !props.match.params.seqNo
                      ? "비대면진료 예약 (1/2)"
                      : "예약정보 수정"
                  }
                  hpKey={hpKey}
                  setPageIdx={setPageIdx}
                  setHsptInfo={setHsptInfo}
                  startTime={
                    props.match.params.seqNo ? hsptInfo.callSTime : startTime
                  }
                  endTime={
                    props.match.params.seqNo ? hsptInfo.callETime : endTime
                  }
                  // hsptInfo={props.match.params.seqNo ? null : hsptInfo}
                  hsptInfo={props.match.params.seqNo ? null : hsptInfo}
                  minTerms={hsptData.appTerm}
                  // backStep={cardInfo ? true : false}
                  backStep={props.match.params.seqNo ? true : backStep}
                  handleDialog={handleDialog}
                  hsptData={hsptData}
                  setMsgState={setMsgState}
                  setViewMsgLayer={setViewMsgLayer}
                />
              )}
              {pageIdx === 3 && (
                <ReceiptTarget
                  hederTitle={
                    !props.match.params.seqNo
                      ? "비대면진료 예약 (1/2)"
                      : "예약정보 수정"
                  }
                  hpKey={hpKey}
                  trgtInfo={trgtInfo}
                  setTrgtInfo={setTrgtInfo}
                  setPageIdx={setPageIdx}
                  fileOrigin={fileOrigin}
                  setFileOrigin={setFileOrigin}
                  fileTemp={fileTemp}
                  setFileTemp={setFileTemp}
                  // backStep={cardInfo ? true : false}
                  backStep={props.match.params.seqNo ? true : backStep}
                  imgTempView={imgTempView}
                  setImgTempView={setImgTempView}
                  seqNo={
                    props.match.params.seqNo ? props.match.params.seqNo : null
                  }
                  setBackStep={setBackStep}
                  familyInfo={familyInfo}
                  setFamilyInfo={setFamilyInfo}
                  setMsgState={setMsgState}
                  setViewMsgLayer={setViewMsgLayer}
                />
              )}
              {/* {pageIdx === 31 && <TargetManagement setPageIdx={setPageIdx} />} */}
              {pageIdx === 4 && (
                <InputSymptom
                  hederTitle={
                    !props.match.params.seqNo
                      ? "비대면진료 예약 (1/2)"
                      : "예약정보 수정"
                  }
                  hpKey={hpKey}
                  setPageIdx={setPageIdx}
                  smptInfo={smptInfo}
                  setSmptInfo={setSmptInfo}
                  // backStep={cardInfo ? true : false}
                  backStep={props.match.params.seqNo ? true : backStep}
                  setMsgState={setMsgState}
                  setViewMsgLayer={setViewMsgLayer}
                />
              )}
              {pageIdx === 5 && (
                <ReceiptCard
                  hederTitle={
                    !props.match.params.seqNo
                      ? "비대면진료 예약 (1/2)"
                      : "예약정보 수정"
                  }
                  hpKey={hpKey}
                  setPageIdx={setPageIdx}
                  cardInfo={cardInfo}
                  setCardInfo={setCardInfo}
                  setMoveUrl={setMoveUrl}
                  returnUrl={returnUrl}
                  // backStep={cardInfo ? true : false}
                  backStep={props.match.params.seqNo ? true : backStep}
                  setBackStep={setBackStep}
                  seqNo={
                    props.match.params.seqNo ? props.match.params.seqNo : null
                  }
                  setMsgState={setMsgState}
                  setViewMsgLayer={setViewMsgLayer}
                />
              )}
              {pageIdx === 6 && (
                <ReceiptComplete
                  hpKey={hpKey}
                  setPageIdx={setPageIdx}
                  submit={receiptRsrv}
                  hsptInfo={hsptInfo}
                  trgtInfo={trgtInfo}
                  smptInfo={smptInfo}
                  cardInfo={cardInfo}
                />
              )}

              {pageIdx === 7 && (
                <ReceiptPharm
                  hederTitle={
                    !props.match.params.seqNo
                      ? "비대면진료 예약 (1/2)"
                      : "예약정보 수정"
                  }
                  setPageIdx={setPageIdx}
                  pharmInfo={pharmInfo}
                  setPharmInfo={setPharmInfo}
                  pharmInfoTemp={pharmInfoTemp}
                  setPharmInfoTemp={setPharmInfoTemp}
                />
              )}

              {pageIdx === 8 && (
                <ReceiptPharmSearch
                  pharmInfo={pharmInfo}
                  setPharmInfo={setPharmInfo}
                  // 뒤로가기
                  backClickEvent={() => setPageIdx(7)}
                  // 저장 후 다음
                  buttonClickEvent={buttonClickEvent}
                />
              )}

              {pageIdx === 9 && (
                <ReceiptIframe setPageIdx={setPageIdx} moveUrl={moveUrl} />
              )}
              {pageIdx === 10 && (
                <ReceiptStepTwo
                  hederTitle={
                    !props.match.params.seqNo
                      ? "비대면진료 예약 (2/2)"
                      : "예약정보 수정"
                  }
                  setPageIdx={setPageIdx}
                  cardInfo={cardInfo}
                  submit={receiptRsrv}
                  seqNo={
                    props.match.params.seqNo ? props.match.params.seqNo : null
                  }
                  couponLayerView={couponLayerView}
                  setCouponLayerView={setCouponLayerView}
                  setIssueCpnNo={setIssueCpnNo}
                  couponInfo={couponInfo}
                  setCouponInfo={setCouponInfo}
                />
              )}
            </Fragment>
          )}

          <AlertLayer
            title={dialog.title}
            msg={dialog.msg}
            handleConfirmCB={() => closeLayerFn(".alert-layer")}
          />

          {viewMsgLayer && (
            <Layer
              headerIcon={getMessage().headerIcon}
              title={getMessage().title}
              desc={getMessage().desc}
              ps={getMessage().ps}
              button={getMessage().button}
            />
          )}

          {toastView.view && (
            <div style={{ paddingLeft: "20px", willChange: "transform" }}>
              <ToastMsg
                option={{
                  img: IC.check.ICON_GREEN_CHECK,
                  bottom: "102px",
                  // bottom: "24px",
                  // text: "결제카드가 추가되었습니다.",
                  text: toastMsgObj[toastView.msgType].text,
                }}
              />
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default ReceiptIndex;


